export default __webpack_public_path__ + "static/media/pipes.3dd6b054.png";